import angular from 'angular';

angular
  .module('depositorconfirm', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('depositor_confirm', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
